module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_18.cf6a9998.png";